import { render } from "./ProjectDatasetInfoDrawerPanel.vue?vue&type=template&id=3d062fb3&scoped=true"
import script from "./ProjectDatasetInfoDrawerPanel.vue?vue&type=script&lang=js"
export * from "./ProjectDatasetInfoDrawerPanel.vue?vue&type=script&lang=js"

import "./ProjectDatasetInfoDrawerPanel.vue?vue&type=style&index=0&id=3d062fb3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d062fb3"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QInnerLoading,QItem,QIcon});
